// extracted by mini-css-extract-plugin
export default {"overlay":"Overlay_overlay__mpfM-","hideOverlay":"Overlay_hideOverlay__Gs6F6","showOverlay":"Overlay_showOverlay__30CZ0"};